import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const IconButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #656668;
  font-size: 12px;
  cursor: pointer;
  width: 100%;
  height: 65px;

  &:hover {
    color: ${({ theme }) => theme['@primary-color']};
  }
`;

function IconButton({ onClick, icon, children }) {
  return (
    <IconButtonWrapper onClick={onClick}>
      {icon}
      {children}
    </IconButtonWrapper>
  );
}

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
};

export default IconButton;
